import appConfig from '../../config/application.json';

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server) {
    const event = useRequestEvent();
    if (event) {
      const reqHost = event.node.req.headers.host;
      const hosts = (appConfig as any).tenants?.root?.default
        ?.hostnameTenantRedirects;
      const tenantObj = hosts?.find(
        (element: any) => element?.host === reqHost,
      );
      const hostHasCountries =
        Array.isArray(tenantObj?.countries) && tenantObj.countries.length > 0;

      if (!hostHasCountries) {
        return;
      }

      const routeCountry = to.meta?.country;
      // Check if tenant has countries configured
      const hasCountriesConfig =
        tenantObj?.countries &&
        Array.isArray(tenantObj.countries) &&
        tenantObj.countries.length > 0;

      if (hasCountriesConfig) {
        // Find the default country from hostname countries configuration
        const defaultCountryObj = tenantObj.countries.find(
          (country: any) => country.default === true,
        );

        if (defaultCountryObj) {
          const actualTenant = defaultCountryObj.tenant;

          if (routeCountry) {
            // Route has a country - check if it's supported
            const isCountrySupported = tenantObj.countries.find(
              (country: any) =>
                country.code.toLowerCase() ===
                (routeCountry as string).toLowerCase(),
            );

            if (!isCountrySupported) {
              // Country not supported - throw 404
              throw createError({
                statusCode: 404,
                statusMessage: 'Not Found',
              });
            }
            // Country is supported - let the route proceed
          } else {
            // No country in route - check if the resolved tenant has defaultCountry
            const tenantConfig = (appConfig as any).tenants[actualTenant];
            const tenantDefaultCountryRedirectTo =
              tenantConfig?.default?.defaultCountry;

            if (tenantDefaultCountryRedirectTo) {
              // The resolved tenant has defaultCountry - redirect to it
              if (to.path === '/') {
                return navigateTo(`/${tenantDefaultCountryRedirectTo}`);
              }
              // For other routes, try to add country prefix
              const routeName = to.name?.toString();
              if (routeName) {
                return navigateTo({
                  name: `${tenantDefaultCountryRedirectTo}${routeName}`,
                  query: to.query,
                  hash: to.hash,
                  params: to.params,
                });
              } else {
                // Fallback to path-based redirect
                return navigateTo(
                  `/${tenantDefaultCountryRedirectTo}${to.path}`,
                );
              }
            }
          }
        }
      } else {
        // No countries configured - normal flow, no redirects
        if (routeCountry) {
          // But route has country - this shouldn't be accessible
          throw createError({
            statusCode: 404,
            statusMessage: 'Not Found',
          });
        }
        // No country in route and no countries configured - proceed normally
      }
    }
  }
});
